


















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

import { DateRange } from '@/models/date-range';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

@Component({
	components: {
		VueCtkDateTimePicker,
	},
})
export default class DatePicker extends Vue {
	@Prop({ type: String, default: null })
	public initialStartDate!: string | null;

	@Prop({ type: String, default: null })
	public initialEndDate!: string | null;

	public get dateRange(): Omit<DateRange, 'shortcut'> {
		return {
			start: this.startDate,
			end: this.endDate,
		};
	}

	public shortcuts: { key: string; label: string; value: string | number }[] = [
		{ key: 'today', label: 'Today', value: 0 },
		{ key: 'yesterday', label: 'Yesterday', value: '-day' },
		{ key: 'last7Days', label: 'Last 7 days', value: 7 },
		{ key: 'last14Days', label: 'Last 14 days', value: 14 },
		{ key: 'thisWeek', label: 'This week', value: 'isoWeek' },
		{ key: 'lastWeek', label: 'Last week', value: '-isoWeek' },
		{ key: 'last10Days', label: 'Last 10 days', value: 10 },
	];

	private get now(): string {
		return this.formatDate(moment());
	}

	private startDate: string = this.initialStartDate ?? this.formatDate(moment().subtract(14, 'days'));
	private endDate: string | undefined = this.initialEndDate ?? this.now;

	public onDateRangeChanged(newDateRange: DateRange): void {
		const { start, end } = newDateRange;
		this.startDate = start;
		this.endDate = end;
	}

	private formatDate(date: moment.Moment): string {
		return date.format('DD-MM-YYYY');
	}

	@Emit('dateRangeChanged')
	private emitDateChange(): Omit<DateRange, 'shortcut'> {
		return this.dateRange;
	}
}
